import API from "../../Api"
import router from "../../Router.js"

const Actions = {

    // Member
    setMember ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("member/save", data).then((res) => {

                commit("setMemberProfile", data);
                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    getEditMember ({commit},memberId) {
        return new Promise((resolve, reject) => {
            API.get("member/GetEditMember?memberId=" + memberId).then((res) => {

                //commit("setEditMember", res.data);
                resolve(res.data)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    deleteMemberSoft ({commit},memberId) {
        return new Promise((resolve, reject) => {
            API.get("member/DeleteMemberSoft?memberId=" + memberId).then((res) => {

                //commit("setEditMember", res.data);
                resolve(res.data)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    saveMemberAdminMode ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("member/SaveAdminMode", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    getMemberActivity ({commit},memberId) {
        return new Promise((resolve, reject) => {
            API.get("member/GetMemberActivity?memberId=" + memberId).then((res) => {

                //commit("setEditMember", res.data);
                resolve(res.data)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    getMember ({commit}) {
        return new Promise((resolve, reject) => {
            API.get("member/get").then((res) => {

                commit("setMemberProfile", res.data);
                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    getMemberList ({commit}) {
        return new Promise((resolve, reject) => {
            API.get("member/list").then((res) => {
                resolve(res.data);

            }).catch((res) => {
                reject(res);
            });
        });
    },

    getSettingsList ({commit}) {
        return new Promise((resolve, reject) => {
            API.get("settings/list").then((res) => {
                resolve(res.data);

            }).catch((res) => {
                reject(res);
            });
        });
    },
    saveSettings ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("settings/SaveSettings", data).then((res) => {
                resolve(res.data);

            }).catch((res) => {
                reject(res);
            });
        });
    },
    createFirstSetting ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("settings/CreateFirstSetting", data).then((res) => {
                resolve(res.data);

            }).catch((res) => {
                reject(res);
            });
        });
    },    
    stopWebsite ({commit}) {
        return new Promise((resolve, reject) => {
            API.post("settings/StopWebsite").then((res) => {
                resolve(res);

            }).catch((res) => {
                reject(res);
            });
        });
    },
    // Project
    getActiveProjects ({commit}) {

        return new Promise((resolve, reject) => {
            API.get("project/GetActive" ).then((res) => {

                //debugger; 
                
                if (res == null) {
                    reject(res);
                }
 
                if(!Array.isArray(res.data)) {
                    
                    resolve(res)
                    return;
                }

                //debugger;
                res.data.forEach((project) => {
                    commit("setProject", project);
                });
                //debugger; 
                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    getAnonymousProject ({commit}, forecastVersionId) {

        return new Promise((resolve, reject) => {
            API.get("project/GetAnonymous?forecastVersionId=" + forecastVersionId).then((res) => {

                commit("setProject", res.data);

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    deleteProject ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("project/delete", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    archiveProject ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("project/archive", data).then((res) => {

                commit("updateProjectUrl", res.data);
                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    renameProject ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("project/rename", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    cloneProject ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("project/clone", data).then((res) => {

                commit("setProject", res.data);
                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    setProject ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("project/add", data).then((res) => {

                commit("setProject", res.data);
                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },



    // Program
    setProgram ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("program/add", data).then((res) => {

                commit("setProgram", res.data);
                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    deleteProgram ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("program/delete", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    archiveProgram ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("program/archive", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    renameProgram ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("program/rename", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    cloneProgram ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("program/clone", data).then((res) => {

                commit("setProgram", res.data);
                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    settingsProgram ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("program/settings", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },



    // Study
    setStudy ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("study/add", data).then((res) => {

                commit("setStudy", res.data);
                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    cloneStudy ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("study/clone", data).then((res) => {

                commit("setStudy", res.data);
                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    deleteStudy ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("study/delete", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    archiveStudy ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("study/archive", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    renameStudy ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("study/rename", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    setSeedStudy ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("study/setseed", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    importStudyJson ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("study/importstudyjson", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    // DataView
    getDataViewForecast ({commit}, id) {
        return new Promise((resolve, reject) => {
            API.get("dataview/getForecast?forecastId=" + id).then((res) => {

                commit("setDataViewForecast", res.data);
                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    getDataViewChart ({commit}, data) {
        return new Promise((resolve, reject) => {
            let url = "dataview/getchart?name=" + data.name + "&id=" + router.currentRoute.params.id;

            if(data.filters && Object.keys(data.filters).length !== 0)
            {
                let hasFilters = false;
                Object.keys(data.filters).forEach(function(key,index) {
                    if(data.filters[key].length > 0)
                        hasFilters = true;
                });

                if(hasFilters)
                    url += "&filters=" + JSON.stringify(data.filters);
            }

            API.get(url).then((res) => {

                resolve(res.data)

            }).catch((res) => {
                reject(res)
            })
        })
    },



    // Forecast
    runAggregator ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("forecast/run", data).then((res) => {

                commit("runStudy", res.data);
                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    validateAggregator ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("forecast/validate", data).then((res) => {

                resolve(res.data)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    getForecastVersion ({commit}, forecastVersionId) {
        return new Promise((resolve, reject) => {
            API.get("forecast/GetVersion?forecastVersionId=" + forecastVersionId).then((res) => {

                commit("setOldForecastVersion", res.data);

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    deleteForecastVersion ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("forecast/deleteversion", data).then((res) => {
                resolve(res)
            }).catch((res) => {
                reject(res)
            })
        })
    },
    saveForecastVersion ({commit}, data) {

        commit("setSaveState", true);

        return new Promise((resolve, reject) => {
            API.post("forecast/saveversion", data).then((res) => {

                if (data.forecastVersionId === undefined && res !== undefined && res.data !== undefined && res.data.forecastVersionId !== undefined)
                {
                    //debugger;
                    commit("setProgramForecastVersionId", res.data);
                }
                
                
                commit("setSaveState", false);
                resolve(res)

            }).catch((res) => {
                commit("setSaveState", false);
                reject(res)
            })
        })
    },
    createTemplateFromVersion ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("template/createTemplateFromVersion", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    getTemplateList ({commit}) {
        return new Promise((resolve, reject) => {
            API.get("template/list").then((res) => {
                resolve(res.data);

            }).catch((res) => {
                reject(res);
            });
        });
    },
    getStaticTemplatesList ({commit}) {
        return new Promise((resolve, reject) => {
            API.get("template/liststatictemplates").then((res) => {
                resolve(res.data);
            }).catch((res) => {
                reject(res);
            });
        });
    },
    renameForecastVersion ({commit}, data) {
        return new Promise((resolve, reject) => {
            API.post("forecast/renameVersion", data).then((res) => {

                resolve(res)

            }).catch((res) => {
                reject(res)
            })
        })
    },
    saveCurrentForecastVersion ({commit, state, getters, dispatch}) {

        //debugger;
        if(state.isSavingStudy)
            return false;

        let version = getters.currentVersion();
        
        if (version === null || version === undefined )
        {
            console.log("Did bit save current forecast version. Version was null");
            return;
        }

        if (version.data === null || version.data === undefined )
        {
            console.log("Version.data was " + version.data);
            return;
        }
        
        if (Object.keys(version.data).length <= 2)
        {
            console.log("Version object was invalid. We don't save it only 2 properties exists.");
            return;
        }
        
        version.updateDate = new Date().toUTCString();

        dispatch("saveForecastVersion", (version));
    }, 
    copyCurrentForecastVersion ({commit, state, getters, dispatch}) {
        return new Promise((resolve, reject) => {
            API.post("forecast/copyversion", getters.currentVersion()).then((res) => {

                commit("setForecastVersion", res.data);
                resolve(res.data)

            }).catch((res) => {
                reject(res)
            })
        })
    },

};

export default Actions
